import { Icon, IconProps } from "../";

export const CancelOvalLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47714 2 2 6.47714 2 12C2 17.5214 6.47714 22 12 22C17.5214 22 22 17.5214 22 12C22 6.47714 17.5214 2 12 2ZM7.05025 7.05025C6.75736 7.34315 6.75736 7.81802 7.05025 8.11091L10.9393 12L7.05025 15.8891C6.75736 16.182 6.75736 16.6569 7.05025 16.9497C7.34315 17.2426 7.81802 17.2426 8.11091 16.9497L12 13.0607L15.8891 16.9497C16.182 17.2426 16.6569 17.2426 16.9497 16.9497C17.2426 16.6569 17.2426 16.182 16.9497 15.8891L13.0607 12L16.9497 8.11091C17.2426 7.81802 17.2426 7.34315 16.9497 7.05025C16.6569 6.75736 16.182 6.75736 15.8891 7.05025L12 10.9393L8.11091 7.05025C7.81802 6.75736 7.34315 6.75736 7.05025 7.05025ZM3.5 12C3.5 7.30557 7.30557 3.5 12 3.5C16.6932 3.5 20.5 7.30557 20.5 12C20.5 16.6932 16.6932 20.5 12 20.5C7.30557 20.5 3.5 16.6932 3.5 12Z"
      />
    </Icon>
  );
};
